// Flowers card game data with rankings by popularity/cultural significance
export const FLOWERS_CARDS = [
  { id: 1, name: "Rose", rank: 1, image: "/images/flowers/flowers_1.jpg" },
  { id: 2, name: "Tulip", rank: 2, image: "/images/flowers/flowers_2.jpg" },
  { id: 3, name: "Sunflower", rank: 3, image: "/images/flowers/flowers_3.jpg" },
  { id: 4, name: "Lily", rank: 4, image: "/images/flowers/flowers_4.jpg" },
  { id: 5, name: "Orchid", rank: 5, image: "/images/flowers/flowers_5.jpg" },
  { id: 6, name: "Daisy", rank: 6, image: "/images/flowers/flowers_6.jpg" },
  { id: 7, name: "Lavender", rank: 7, image: "/images/flowers/flowers_7.jpg" },
  { id: 8, name: "Peony", rank: 8, image: "/images/flowers/flowers_8.jpg" },
  { id: 9, name: "Hydrangea", rank: 9, image: "/images/flowers/flowers_9.jpg" },
  { id: 10, name: "Carnation", rank: 10, image: "/images/flowers/flowers_10.jpg" },
  { id: 11, name: "Daffodil", rank: 11, image: "/images/flowers/flowers_11.jpg" },
  { id: 12, name: "Cherry Blossom", rank: 12, image: "/images/flowers/flowers_12.jpg" },
  { id: 13, name: "Hibiscus", rank: 13, image: "/images/flowers/flowers_13.jpg" },
  { id: 14, name: "Marigold", rank: 14, image: "/images/flowers/flowers_14.jpg" },
  { id: 15, name: "Chrysanthemum", rank: 15, image: "/images/flowers/flowers_15.jpg" },
  { id: 16, name: "Iris", rank: 16, image: "/images/flowers/flowers_16.jpg" },
  { id: 17, name: "Poppy", rank: 17, image: "/images/flowers/flowers_17.jpg" },
  { id: 18, name: "Jasmine", rank: 18, image: "/images/flowers/flowers_18.jpg" },
  { id: 19, name: "Magnolia", rank: 19, image: "/images/flowers/flowers_19.jpg" },
  { id: 20, name: "Lotus", rank: 20, image: "/images/flowers/flowers_20.jpg" },
  { id: 21, name: "Gardenia", rank: 21, image: "/images/flowers/flowers_21.jpg" },
  { id: 22, name: "Dahlia", rank: 22, image: "/images/flowers/flowers_22.jpg" },
  { id: 23, name: "Camellia", rank: 23, image: "/images/flowers/flowers_23.jpg" },
  { id: 24, name: "Zinnia", rank: 24, image: "/images/flowers/flowers_24.jpg" },
  { id: 25, name: "Bluebell", rank: 25, image: "/images/flowers/flowers_25.jpg" },
  { id: 26, name: "Wisteria", rank: 26, image: "/images/flowers/flowers_26.jpg" },
  { id: 27, name: "Ranunculus", rank: 27, image: "/images/flowers/flowers_27.jpg" },
  { id: 28, name: "Anemone", rank: 28, image: "/images/flowers/flowers_28.jpg" },
  { id: 29, name: "Freesia", rank: 29, image: "/images/flowers/flowers_29.jpg" },
  { id: 30, name: "Protea", rank: 30, image: "/images/flowers/flowers_30.jpg" }
];
